export default "__VITE_ASSET__9cbc9e85__"